import React, { ReactNode } from "react";
import { jobDetailPath } from "./jobPostingSchema";

interface ClickLike {
  altKey: boolean;
  button: number;
  ctrlKey: boolean;
  metaKey: boolean;
  shiftKey: boolean;
}

export function isUnmodifiedLeftClick(event: ClickLike): boolean {
  return (
    event.button === 0 &&
    !event.metaKey &&
    !event.ctrlKey &&
    !event.shiftKey &&
    !event.altKey
  );
}

interface Props {
  children: ReactNode;
  refId?: string;
}

export default function JobDetailLink(props: Props): JSX.Element {
  const { children, refId } = props;
  if (!refId) {
    return <>{children}</>;
  }
  return (
    <a
      href={jobDetailPath(refId)}
      onClick={(event) => {
        if (isUnmodifiedLeftClick(event)) {
          event.preventDefault();
        }
      }}
      style={{ color: "inherit", textDecoration: "none" }}
    >
      {children}
    </a>
  );
}
